import React from 'react';
import { useGLTF } from '@react-three/drei';

const FloorPlatformModel = () => {
    const { scene } = useGLTF('/GodotBotPlatform.glb'); // Path to your Tree model
    return <primitive object={scene} scale={[4, 4, 4]} position={[-1.3, 0.2, 0]} rotation={[0,0,0]}/>;
  };
  
  export default FloorPlatformModel;